(function () {

  /* =========================================================
     Helpers
  ========================================================= */

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, m =>
      ({ "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;" }[m])
    );
  }

  function iconByKey(key) {
    return (window.__careIcons && window.__careIcons[key]) || "";
  }

  /* =========================================================
     Icon Mapping
  ========================================================= */

  function getIconKey(label) {
    const k = label.toLowerCase();

    if (k.includes("normalwaschgang 30")) return "wash30";
    if (k.includes("normalwaschgang 40")) return "wash40";
    if (k.includes("normalwaschgang 60")) return "wash60";
    if (k.includes("normalwaschgang 90")) return "wash90";
    if (k.includes("schonwaschgang") || k.includes("feinwaschgang")) return "washDelicate";
    if (k.includes("handwäsche") || k.includes("handwaesche")) return "handwash";
    if (k.includes("nicht waschen")) return "noWash";

    if (k.includes("nicht bleichen")) return "noBleach";

    if (k.includes("nicht bügeln") || k.includes("nicht bugeln")) return "noIron";
    if (k.includes("warm bügeln") || k.includes("warm bugeln") || k.includes("110")) return "iron110";
    if (k.includes("heiß bügeln") || k.includes("heiss bugeln") || k.includes("150")) return "iron150";

    if (k.includes("chemische reinigung nicht möglich")) return "noDryclean";
    if (k.includes("chemische reinigung möglich")) return "dryclean";

    if (k.includes("nicht trocknen")) return "noTumble";
    if (k.includes("trocknen möglich")) return "tumble";

    if (k.includes("glas/gable") || k.includes("lebensmittelkontakt")) return "food";
    if (k.includes("spülmaschinen")) return "dishwasher";
    if (k.includes("mikrowellen geeignet")) return "microwave";
    if (k.includes("nicht mikrowellen")) return "noMicrowave";
    if (k.includes("gefriergeeignet")) return "freezer";
    if (k.includes("bpa")) return "bpa";
    if (/\bpp\b/.test(k)) return "pp";
    if (k.includes("360") || k.includes("100")) return "max";

    return "info";
  }



  function ensureTooltip() {
    let tip = document.getElementById("care-global-tooltip");
    if (tip) return tip;

    tip = document.createElement("div");
    tip.id = "care-global-tooltip";
    tip.style.position = "fixed";
    tip.style.zIndex = "999999";
    tip.style.padding = "8px 10px";
    tip.style.fontSize = "12px";
    tip.style.lineHeight = "1.2";
    tip.style.background = "#111";
    tip.style.color = "#fff";
    tip.style.borderRadius = "8px";
    tip.style.whiteSpace = "nowrap";
    tip.style.pointerEvents = "none";
    tip.style.boxShadow = "0 8px 24px rgba(0,0,0,.25)";
    tip.style.transform = "translate(-9999px,-9999px)";
    document.body.appendChild(tip);
    return tip;
  }

  function positionTooltip(tip, el) {
    const r = el.getBoundingClientRect();
    const pad = 8;

    tip.style.transform = "translate(0,0)";
    tip.style.visibility = "hidden";

    const tr = tip.getBoundingClientRect();

    let left = r.left + r.width / 2 - tr.width / 2;
    let top = r.top - tr.height - 10;

    if (top < pad) top = r.bottom + 10;
    left = Math.max(pad, Math.min(left, window.innerWidth - tr.width - pad));
    top = Math.max(pad, Math.min(top, window.innerHeight - tr.height - pad));

    tip.style.left = `${left}px`;
    tip.style.top = `${top}px`;
    tip.style.visibility = "visible";
  }

  function bindTooltipEvents() {
    if (window.__careTooltipBound) return;
    window.__careTooltipBound = true;

    const tip = ensureTooltip();
    let active = null;

    const isTouch = window.matchMedia("(hover: none)").matches;

    function show(el) {
      tip.textContent = el.getAttribute("aria-label") || "";
      active = el;
      positionTooltip(tip, el);
    }

    function hide() {
      active = null;
      tip.style.transform = "translate(-9999px,-9999px)";
    }

    document.addEventListener("pointerdown", (e) => {
      const el = e.target.closest(".care-icon");
      if (!el) {
        hide();
        return;
      }

      if (isTouch) {
        e.preventDefault();
        active === el ? hide() : show(el);
      }
    }, { passive: false });

    if (!isTouch) {
      document.addEventListener("pointerover", e => {
        const el = e.target.closest(".care-icon");
        if (el) show(el);
      });

      document.addEventListener("pointerout", e => {
        if (e.target.closest(".care-icon")) hide();
      });
    }

    window.addEventListener("scroll", () => active && positionTooltip(tip, active), true);
    window.addEventListener("resize", () => active && positionTooltip(tip, active));
  }

  /* =========================================================
     Render Pflegehinweise
  ========================================================= */

  function enhance(scope = document) {
    const rows = scope.querySelectorAll(".accordion__content p");

    rows.forEach(p => {
      const strong = p.querySelector("strong");
      const field = p.querySelector("span.metafield-multi_line_text_field");

      if (!strong || !field) return;
      if (strong.textContent.trim().toLowerCase() !== "pflegehinweise") return;
      if (field.dataset.careEnhanced) return;

      const raw = field.textContent.trim();
      if (!raw) return;

      const parts = raw.split(",").map(x => x.trim()).filter(Boolean);

      const html = parts.map(txt => {
        const key = getIconKey(txt);
        return `
          <button class="care-icon" type="button" aria-label="${escapeHtml(txt)}">
            <img src="${iconByKey(key)}" width="32" height="32" loading="lazy" alt="">
          </button>
        `;
      }).join("");

      field.innerHTML = `<div class="care-icons">${html}</div>`;
      field.dataset.careEnhanced = "true";
    });
  }

  /* =========================================================
     Styles
  ========================================================= */

  function injectStyles() {
    if (document.getElementById("care-style")) return;

    const s = document.createElement("style");
    s.id = "care-style";
    s.textContent = `
      .care-icons{display:flex;flex-wrap:wrap;gap:10px}
      .care-icon{
        width:44px;height:44px;
        border:1px solid rgba(0,0,0,.12);
        border-radius:10px;
        background:#fff;
        display:flex;
        align-items:center;
        justify-content:center;
        cursor:pointer;
        -webkit-tap-highlight-color: transparent;
      }
      .care-icon img{width:32px;height:32px}
      .care-icon:focus{outline:2px solid rgba(0,0,0,.35);outline-offset:2px}
    `;
    document.head.appendChild(s);
  }

  /* =========================================================
     Init
  ========================================================= */

  function init() {
    if (!window.__careIcons) return;
    injectStyles();
    bindTooltipEvents();
    enhance(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

})();
